export enum EnrollmentActionTypeEnum {
  CREATE_ENROLLMENT_VIA_LEC = 'CREATE_ENROLLMENT_VIA_LEC',
  CREATE_ENROLLMENT_VIA_INTERNET = 'CREATE_ENROLLMENT_VIA_INTERNET',
  SEND_PROPOSAL = 'SEND_PROPOSAL',
  SEND_CERTIFICATE = 'SEND_CERTIFICATE',
  SEND_PAYMENT_LINK = 'SEND_PAYMENT_LINK',
  CONFIRM_REGISTRATION = 'CONFIRM_REGISTRATION',
  DIFFUSE_ENROLLMENT_INFORMATION = 'DIFFUSE_ENROLLMENT_INFORMATION',
  CANCEL_ENROLLMENT = 'CANCEL_ENROLLMENT',
  UPDATE_ENROLLMENT = 'UPDATE_ENROLLMENT',
  REFUND_ENROLLMENT = 'REFUND_ENROLLMENT',
  ADD_TARIFF_ADJUSTMENT = 'ADD_TARIFF_ADJUSTMENT',
  ADD_REPATRIATION_INSURANCE = 'ADD_REPATRIATION_INSURANCE',
  REMOVE_REPATRIATION_INSURANCE = 'REMOVE_REPATRIATION_INSURANCE',
  CANCEL_ENROLLMENT_RAD_PASSED = 'CANCEL_ENROLLMENT_RAD_PASSED',
  CANCEL_ENROLLMENT_DIFFUSION_DEADLINE_PASSED = 'CANCEL_ENROLLMENT_DIFFUSION_DEADLINE_PASSED',
  CANCEL_ENROLLMENT_TRIP_FOLDER_LOCKED = 'CANCEL_ENROLLMENT_TRIP_FOLDER_LOCKED',
  SEND_CSE_VALIDATION_REQUEST = 'SEND_CSE_VALIDATION_REQUEST',
  VALIDATE_CSE = 'VALIDATE_CSE',
  REJECT_CSE = 'REJECT_CSE'
}

export const enrollmentActionTypeEnumMapping: Record<EnrollmentActionTypeEnum, string> = {
  [EnrollmentActionTypeEnum.CREATE_ENROLLMENT_VIA_LEC]: 'Création du Bulletin',
  [EnrollmentActionTypeEnum.CREATE_ENROLLMENT_VIA_INTERNET]: 'Création du Bulletin',
  [EnrollmentActionTypeEnum.SEND_PROPOSAL]: 'Envoyer une proposition',
  [EnrollmentActionTypeEnum.SEND_CERTIFICATE]: 'Envoyer une attestation',
  [EnrollmentActionTypeEnum.SEND_PAYMENT_LINK]: 'Envoyer un lien de paiement',
  [EnrollmentActionTypeEnum.CONFIRM_REGISTRATION]: "Confirmation de l'inscription",
  [EnrollmentActionTypeEnum.DIFFUSE_ENROLLMENT_INFORMATION]: 'Diffusion des informations',
  [EnrollmentActionTypeEnum.CANCEL_ENROLLMENT]: 'Annulation du Bulletin',
  [EnrollmentActionTypeEnum.UPDATE_ENROLLMENT]: 'Mise à jour du Bulletin',
  [EnrollmentActionTypeEnum.REFUND_ENROLLMENT]: 'Remboursement du Bulletin',
  [EnrollmentActionTypeEnum.ADD_TARIFF_ADJUSTMENT]: 'Ajustement du Bulletin',
  [EnrollmentActionTypeEnum.ADD_REPATRIATION_INSURANCE]: "Ajout d'une assurance rapatriement",
  [EnrollmentActionTypeEnum.REMOVE_REPATRIATION_INSURANCE]:
    "Suppression d'une assurance rapatriement",
  [EnrollmentActionTypeEnum.CANCEL_ENROLLMENT_RAD_PASSED]: 'Annulation du Bulletin (RAD dépassé)',
  [EnrollmentActionTypeEnum.CANCEL_ENROLLMENT_DIFFUSION_DEADLINE_PASSED]:
    'Annulation du Bulletin (date limite de diffusion dépassée)',
  [EnrollmentActionTypeEnum.CANCEL_ENROLLMENT_TRIP_FOLDER_LOCKED]:
    'Annulation du Bulletin (dossier de voyage verrouillé)',
  [EnrollmentActionTypeEnum.SEND_CSE_VALIDATION_REQUEST]: 'Envoi du Bulletin au CSE',
  [EnrollmentActionTypeEnum.VALIDATE_CSE]: 'Validation du Bulletin par le CSE',
  [EnrollmentActionTypeEnum.REJECT_CSE]: 'Refus du Bulletin par le CSE'
}
